import React from "react";
import { init } from "@module-federation/runtime";
import ReactDOM from "react-dom";

/**
 * Common method to initialize a remote app using Module Federation.
 *
 * @param {string} remoteUrl - The base URL of the remote app.
 * @param {string} remoteScope - The scope name of the remote app.
 * @param {Object} sharedDependencies - Shared dependencies configuration.
 * @returns {Promise<void>} - Resolves when the initialization is complete.
 */

const validateRemoteEntry = async (url: string) => {
  try {
      const response = await fetch(url);
      if (!response.ok) {
          throw new Error(`Failed to fetch remote entry: ${response.statusText}`);
      }
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/javascript')) {
          throw new Error(`Invalid content type for remote entry: ${contentType}`);
      }
  } catch (error) {
      console.error(`Error validating remote entry at ${url}:`, error);
      throw error;
  }
};
export const InitializeRemoteApp = async (
  remoteUrl: string,
  remoteScope: string,
  sharedDependencies: Record<string, any> = {}
): Promise<void> => {
  try {
    const cacheBustedUrl = `${remoteUrl}/remoteEntry.js?cb=${Date.now()}`;

    // Default shared dependencies
    const defaultSharedDependencies = {
      react: {
        version: "18.3.1",
        scope: "default",
        lib: () => React,
        shareConfig: {
          singleton: true,
          requiredVersion: "^18.3.1",
        },
      },
      "react-dom": {
        version: "18.2.0",
        scope: "default",
        lib: () => ReactDOM,
        shareConfig: {
          singleton: true,
          requiredVersion: "^18.2.0",
        },
      },
    };

    // Merge default and custom shared dependencies
    const mergedSharedDependencies = {
      ...defaultSharedDependencies,
      ...sharedDependencies,
    };
    // await validateRemoteEntry(remoteUrl);
    // Initialize the remote app
    await init({
      name: "host-app",
      remotes: [
        {
          name: remoteScope,
          entry: cacheBustedUrl,
          entryGlobalName: remoteScope,
        },
      ],
      shared: mergedSharedDependencies,
    });

    console.log(`Remote app "${remoteScope}" initialized successfully.`);
  } catch (error) {
    console.error(`Failed to initialize remote app "${remoteScope}":`, error);
    throw error;
  }
};